import { createContext, useState } from "react";
import { setToLocalStorage, removeFromLocalStorage } from "../../lib/localStorage";

const PluginsContext = createContext();

export function PluginsContextProvider({ children }) {
    const [activePluginsByAccount, setActivePluginsByAccount] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('activePlugins')) || [];
        } catch (error) {
            console.error("Failed to parse active plugins from localStorage", error);
            return [];
        }
    });

    const saveActiveToContext = (newActive, accountName) => {
        setActivePluginsByAccount((prevPlugins) => {
            const updatedPlugins = [...prevPlugins];
            const accountIndex = updatedPlugins.findIndex(el => el.accountName === accountName);
            const newEntry = { active: newActive, accountName };

            if (accountIndex === -1) {
                updatedPlugins.push(newEntry);
            } else {
                updatedPlugins[accountIndex] = newEntry;
            }

            setToLocalStorage('activePlugins', updatedPlugins);
            return updatedPlugins;
        });
    };

    const updatePluginsContext = ({ status, plugin, guiname }) => {
        setActivePluginsByAccount((prevPlugins) => {
            const updatedPlugins = prevPlugins.map(account => {
                if (account.accountName === guiname) {
                    const updatedActive = status
                        ? Array.from(new Set([...account.active, Number(plugin)]))
                        : account.active.filter(item => item !== Number(plugin));
                    return { ...account, active: updatedActive };
                }
                return account;
            });

            setToLocalStorage('activePlugins', updatedPlugins);
            return updatedPlugins;
        });
    };

    const clearPluginsContext = () => {
        setActivePluginsByAccount([]);
        removeFromLocalStorage('activePlugins');
    };

    const getActiveByAccountName = (accountName) => {
        try {
            return activePluginsByAccount.find(acc => acc.accountName === accountName) || null;
        } catch (error) {
            console.error("Failed to get active plugins by account name", error);
            return null;
        }
    };

    const valueToShare = {
        active: activePluginsByAccount,
        saveActiveToContext,
        clearPluginsContext,
        getActiveByAccountName,
        updatePluginsContext,
    };

    return (
        <PluginsContext.Provider value={valueToShare}>
            {children}
        </PluginsContext.Provider>
    );
}

export default PluginsContext;
